import {useState} from 'react'
import {RadioGroup} from '@headlessui/react'
import {MailIcon, PhoneIcon} from '@heroicons/react/outline'
import TextField from "../../../../shared/components/inputs/TextField";
import TextArea from "../../../../shared/components/inputs/TextArea";
import {classNames} from "../../../../shared/utils/Utils";
import {useTranslation} from "react-i18next";

export default function ContactSection() {
    const {t} = useTranslation();
    return (
        <div className="relative bg-white" id="contact-us">
            <div className="absolute inset-0">
                <div className="absolute inset-y-0 left-0 w-1/2 bg-gray-50"/>
            </div>
            <div className="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5">
                <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12">
                    <div className="max-w-lg mx-auto">
                        <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">{t('home.contact-us.name')}</h2>
                        <p className="mt-3 text-lg leading-6 text-gray-500">
                            {t('home.contact-us.description')}
                        </p>
                        <dl className="mt-8 text-base text-gray-500">
                            <div>
                                <dt className="sr-only">Postal address</dt>
                                <dd>
                                    <p>{t('home.contact-us.address-1')}</p>
                                    <p>{t('home.contact-us.address-2')}</p>
                                </dd>
                            </div>
                            <div className="mt-6">
                                <dt className="sr-only">Phone number</dt>
                                <dd className="flex">
                                    <PhoneIcon className="flex-shrink-0 h-6 w-6 text-gray-400" aria-hidden="true"/>
                                    <span className="ml-3">{t('home.contact-us.tel')}</span>
                                </dd>
                            </div>
                            <div className="mt-3">
                                <dt className="sr-only">Email</dt>
                                <dd className="flex">
                                    <MailIcon className="flex-shrink-0 h-6 w-6 text-gray-400" aria-hidden="true"/>
                                    <span className="ml-3">{t('home.contact-us.email')}</span>
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
                <div className="bg-white py-16 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-8 xl:pl-12">
                    <div className="max-w-lg mx-auto lg:max-w-none">
                        <form action="" method="GET" className="grid grid-cols-1 gap-y-6">
                            <TextField title="Full Name" id="full-name"/>
                            <TextField title="Email" type="email" id="email-address"/>
                            <TextField title="Phone" type="phone" id="phone-number"/>
                            <FunctionListRadio/>
                            <TextField title="Subject"/>
                            <TextArea title="Message"/>
                            <div>
                                <button
                                    type="submit"
                                    className="inline-flex justify-center py-3 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    Send
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )

    function FunctionListRadio() {
        const {t} = useTranslation();
        const functions = [
            ...t('home.contact-us.inputs.functions').split(',')
        ]
        const [selected, setSelected] = useState(functions[0])

        return (
            <RadioGroup value={selected} onChange={setSelected}>
                <label htmlFor="first-name" className="block text-sm text-md py-2 font-medium text-gray-700">
                    Functions
                </label>
                <RadioGroup.Label className="sr-only">Fucntion</RadioGroup.Label>
                <div className="relative bg-white rounded-md -space-y-px">
                    {functions.map((plan, planIdx) => (
                        <RadioGroup.Option
                            key={plan}
                            value={plan}
                            className={({checked}) =>
                                classNames(
                                    planIdx === 0 ? 'rounded-tl-md rounded-tr-md' : '',
                                    planIdx === functions.length - 1 ? 'rounded-bl-md rounded-br-md' : '',
                                    checked ? 'bg-indigo-50 border-indigo-200 z-10' : 'border-gray-200',
                                    'relative border p-4 flex flex-col cursor-pointer md:pl-4 md:pr-6 md:grid md:grid-cols-3 focus:outline-none'
                                )
                            }
                        >
                            {({active, checked}) => (
                                <>
                                    <div className="flex items-center text-sm">
                  <span
                      className={classNames(
                          checked ? 'bg-indigo-600 border-transparent' : 'bg-white border-gray-300',
                          active ? 'ring-2 ring-offset-2 ring-indigo-500' : '',
                          'h-4 w-4 rounded-full border flex items-center justify-center'
                      )}
                      aria-hidden="true"
                  >
                    <span className="rounded-full bg-white w-1.5 h-1.5"/>
                  </span>
                                        <RadioGroup.Label
                                            as="span"
                                            className={classNames(checked ? 'text-indigo-900' : 'text-gray-900', 'ml-3 font-medium')}
                                        >
                                            {plan}
                                        </RadioGroup.Label>
                                    </div>

                                </>
                            )}
                        </RadioGroup.Option>
                    ))}
                </div>
            </RadioGroup>
        )
    }

}
